<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M55.9 56.72l-4.85-34a2 2 0 00-2-1.72h-8.11a10.5 10.5 0 10-17.88 0h-8.13a2 2 0 00-2 1.72l-4.85 34a2 2 0 00.47 1.59 2 2 0 001.51.69h43.86a2 2 0 001.51-.69 2 2 0 00.47-1.59zM26.7 20.8a7.43 7.43 0 01-2.2-5.3 7.5 7.5 0 1112.75 5.36s-.06.1-.1.14H26.83c-.05-.06-.08-.14-.13-.2zM11.23 56l4.57-32h32.4l4.57 32z"/></svg>